import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getStatusMark } from 'src/app/const/entity-view-constants';
import { EntityStatus, ItemStatus } from 'src/app/interfaces/views.interface';

@Component({
  selector: 'app-public-link',
  templateUrl: './public-link.component.html',
  styleUrls: ['./public-link.component.scss'],
})
export class PublicLinkComponent {
  @Input({ required: true }) public url: string;
  @Input({ required: true }) public urlParams: object;
  @Input({ required: true }) public text: string;
  @Input({ required: true }) public status: EntityStatus;

  @Input({ required: false }) public isActiveLink = true;
  @Input({ required: false }) public isHideStatus = false;
  @Input({ required: false }) public cssStyles = '';
  @Input({ required: false }) public needComma: boolean;
  @Input({ required: false }) public openInNewWindow = false;

  @Output() public submit: EventEmitter<void> = new EventEmitter<void>();

  public get statusMark(): string {
    return !this.isHideStatus ? getStatusMark(this.status) : ItemStatus.EMPTY;
  }

  public onSubmit(): void {
    this.submit.emit();
  }

  public getStatusMark(): string {
    return getStatusMark(this.status);
  }
}
